  import React, { useState } from "react";
  import DateRangePickerComponent from "./CustomDateRangePicker";
  import apiClient from "../utils/apiClient";
  import moment from "moment";
  import "bootstrap/dist/css/bootstrap.min.css";
  import { Link } from "react-router-dom";
  import ExcelJS from "exceljs";
  import { saveAs } from "file-saver";
  import Select from "react-select";

  const PendingReturnableReport = () => {
    const [dateRange, setDateRange] = useState([null, null]);
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [openRow, setOpenRow] = useState(null);
    const [selectedLedger, setSelectedLedger] = useState("");
    const [showPending, setShowPending] = useState(true);
const [showCompleted, setShowCompleted] = useState(false);

    const ledgerOptions = [
      { value: "ALL", label: "All Ledgers" },
      ...Array.from(new Set(tableData.map(r => r.partyName))).map(l => ({
        value: l,
        label: l,
      })),
    ];
    
    

    const exportToExcel = async () => {
      if (!tableData || tableData.length === 0) {
        alert("No data to export");
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const sheetName = "Pending Returnables";
      const sheet = workbook.addWorksheet(sheetName);

      /* ============================
        TABLE 1 : SUMMARY
      ============================ */

      sheet.columns = [
        { header: "S.No", width: 8 },
        { header: "Ledger", width: 40 },
        { header: "Item", width: 25 },
        { header: "Issued", width: 12 },
        { header: "Returned", width: 12 },
        { header: "Pending", width: 12 },
      ];

      // Header style
      sheet.getRow(1).eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: "center" };
      });

      let sno = 0;
      const issuedDetailRows = [];
      const returnedDetailRows = [];
      const issuedRowLinkMap = {}; // sno -> first issued detail row number

      /* ============================
        SUMMARY ROWS
      ============================ */

      const excelData =
    selectedLedger && selectedLedger.value != "ALL"
      ? tableData.filter(r => r.partyName == selectedLedger.value)
      : tableData;

  excelData.forEach((row) => {

        sno++;

        sheet.addRow([
          sno,
          row.partyName,
          row.itemName,
          row.totalIssued,
          row.totalReturned,
          row.pending,
        ]);

        // Collect Issued Details
        if (row.issuedDetails?.length > 0) {
          row.issuedDetails.forEach((d) => {
            issuedDetailRows.push({
              sno,
              date: moment(d.date).format("DD-MM-YYYY"),
              challan: d.challanNo,
              qty: d.issuedQty,
            });
          });
        }

        // Collect Returned Details
        if (row.returnedDetails?.length > 0) {
          row.returnedDetails.forEach((d) => {
            returnedDetailRows.push({
              sno,
              date: moment(d.date).format("DD-MM-YYYY"),
              voucher: d.voucherNo,
              qty: d.returnedQty,
            });
          });
        }
      });

      const summaryEndRow = sheet.lastRow.number;

      sheet.addRow([]);
      sheet.addRow([]);

      if (issuedDetailRows.length > 0) {
        const issuedTitleRowNo = sheet.lastRow.number + 1;

        const issuedTitle = sheet.addRow(["Issued Details"]);
        issuedTitle.font = { bold: true };
        sheet.mergeCells(`A${issuedTitleRowNo}:D${issuedTitleRowNo}`);

        const issuedHeader = sheet.addRow([
          "S.No",
          "Issue Date",
          "Challan No",
          "Issued Qty",
        ]);

        issuedHeader.eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { horizontal: "center" };
        });

        issuedDetailRows.forEach((d) => {
          const r = sheet.addRow([d.sno, d.date, d.challan, d.qty]);

          // Save FIRST issued detail row per S.No for hyperlink target
          if (!issuedRowLinkMap[d.sno]) {
            issuedRowLinkMap[d.sno] = r.number;
          }
        });
      }


      if (returnedDetailRows.length > 0) {
        sheet.addRow([]);
        sheet.addRow([]);

        const returnedTitleRowNo = sheet.lastRow.number + 1;

        const returnedTitle = sheet.addRow(["Returned Details"]);
        returnedTitle.font = { bold: true };
        sheet.mergeCells(`A${returnedTitleRowNo}:D${returnedTitleRowNo}`);

        const returnedHeader = sheet.addRow([
          "S.No",
          "Return Date",
          "Voucher No",
          "Returned Qty",
        ]);

        returnedHeader.eachCell((cell) => {
          cell.font = { bold: true };
          cell.alignment = { horizontal: "center" };
        });

        returnedDetailRows.forEach((d) => {
          sheet.addRow([d.sno, d.date, d.voucher, d.qty]);
        });
      }


      for (let r = 2; r <= summaryEndRow; r++) {
        const row = sheet.getRow(r);

        const snoCell = row.getCell(1);
        const issuedCell = row.getCell(4);

        const snoVal = snoCell.value;

        if (issuedRowLinkMap[snoVal]) {
          const targetRow = issuedRowLinkMap[snoVal];
          const link = `#'${sheetName}'!A${targetRow}`;

          // Link on S.No
          snoCell.value = {
            text: snoVal.toString(),
            hyperlink: link,
          };
          snoCell.font = { color: { argb: "FF0000FF" }, underline: true };

          // Link on Issued Qty
          issuedCell.value = {
            text: issuedCell.value.toString(),
            hyperlink: link,
          };
          issuedCell.font = { color: { argb: "FF0000FF" }, underline: true };
        }
      }

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(
        blob,
        `Pending_Returnables_${moment().format("DD-MM-YYYY")}.xlsx`
      );
    };


    // 🔥 Fetch data from API
    const fetchPendingReturnable = async () => {
      // ✅ Date validation
      if (!dateRange[0] || !dateRange[1]) {
        setError("Please select date range first");
        return;
      }
      try {
        setLoading(true);
        setError("");

        const payload = {
          start: moment(dateRange[0]).format("YYYY-MM-DD"),
          end: moment(dateRange[1]).format("YYYY-MM-DD"),
        };

        const res = await apiClient.post("/getPendingReturnableData", payload);

        setTableData(res.data || []);
      } catch (err) {
        console.error(err);
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };
    const filteredData =
    selectedLedger && selectedLedger.value !== "ALL"
      ? tableData.filter((r) => r.partyName === selectedLedger.value)
      : tableData;
  
  const pendingRows = filteredData.filter((r) => Number(r.pending) > 0);
  const completedRows = filteredData.filter((r) => Number(r.pending) === 0);
  
  const groupedPending = pendingRows.reduce((acc, row) => {
    if (!acc[row.partyName]) acc[row.partyName] = [];
    acc[row.partyName].push(row);
    return acc;
  }, {});
  
  const groupedCompleted = completedRows.reduce((acc, row) => {
    if (!acc[row.partyName]) acc[row.partyName] = [];
    acc[row.partyName].push(row);
    return acc;
  }, {});
  
  



    let serialNo = 0;
    const renderTable = (groupedData, type) => {
      let serialNoLocal = 0;
    
      return (
        <div className="table-responsive mt-2">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Ledger</th>
                <th>Item</th>
                <th>Issued</th>
                <th>Returned</th>
                <th>Pending</th>
                <th>Details</th>
              </tr>
            </thead>
    
            <tbody>
              {Object.keys(groupedData).length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Data Found
                  </td>
                </tr>
              ) : (
                Object.entries(groupedData).map(([ledger, rows]) =>
                  rows.map((row) => {
                    serialNoLocal++;
    
                    return (
                      <React.Fragment key={`${type}-${row.itemId}`}>
                        {/* MAIN ROW */}
                        <tr>
                          <td className="fw-bold text-center">{serialNoLocal}</td>
                          <td>{ledger}</td>
                          <td>{row.itemName}</td>
                          <td className="fw-bold">{row.totalIssued}</td>
                          <td className="fw-bold">{row.totalReturned}</td>
    
                          <td
                            className={`fw-bold ${
                              Number(row.pending) === 0 ? "text-success" : "text-danger"
                            }`}
                          >
                            {row.pending}
                          </td>
    
                          <td className="text-center">
                            <button
                              className="btn btn-sm btn-info"
                              onClick={() =>
                                setOpenRow(openRow === row.itemId ? null : row.itemId)
                              }
                            >
                              {openRow === row.itemId ? "Hide" : "Details"}
                            </button>
                          </td>
                        </tr>
    
                        {/* DETAILS ROW */}
                        {openRow == row.itemId && (
                          <tr>
                            <td></td>
                            <td></td>
                            <td colSpan="5">
                              <div className="p-2 border rounded bg-light">
                                <h6>Issued Details</h6>
    
                                <table className="table table-sm table-bordered mb-3">
                                  <thead>
                                    <tr>
                                      <th>Date</th>
                                      <th>Challan No</th>
                                      <th>Issued Qty</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {row.issuedDetails.map((d, i) => (
                                      <tr key={i}>
                                        <td>{moment(d.date).format("DD-MM-YYYY")}</td>
                                        <td>
                                          <Link
                                            to={`/previewDeliveryChallan?challanId=${d.id}&type=challan`}
                                            target="_blank"
                                          >
                                            {d.challanNo}
                                          </Link>
                                        </td>
                                        <td>{d.issuedQty}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
    
                                {row.returnedDetails?.length > 0 && (
                                  <>
                                    <h6>Returned Details</h6>
                                    <table className="table table-sm table-bordered">
                                      <thead>
                                        <tr>
                                          <th>Date</th>
                                          <th>Voucher No</th>
                                          <th>Returned Qty</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {row.returnedDetails.map((d, i) => (
                                          <tr key={i}>
                                            <td>{moment(d.date).format("DD-MM-YYYY")}</td>
                                            <td>
                                              <Link
                                                to={`/PreviewExternalReceiptVoucher?voucherId=${d.id}&type=external`}
                                                target="_blank"
                                              >
                                                {d.voucherNo}
                                              </Link>
                                            </td>
                                            <td>{d.returnedQty}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </>
                                )}
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })
                )
              )}
            </tbody>
          </table>
        </div>
      );
    };
    
    return (
      <div className="formcontainer mt-3">
        <h5 className="mb-3">Pending Returnables</h5>

        {/* Filters */}
        <div className="row mb-3">
          <div className="col-md-3">
            <label className="form-label">Date Range</label>
            <DateRangePickerComponent value={dateRange} onChange={setDateRange} />
          </div>
          {tableData?.length>0 && (
          <div className="col-md-3">
    <label className="form-label">Ledger</label>
    <Select
      options={ledgerOptions}
      value={selectedLedger}
      onChange={setSelectedLedger}
      isClearable
      placeholder="Select Ledger"
      classNamePrefix="react-select"
    />
  </div>
  )}


          {/* GET REPORT BUTTON */}
          <div className="col-md-2 d-flex align-items-end">
            <button
              className="btn btn-outline-success w-100"
              onClick={fetchPendingReturnable}
            >
              Get Report
            </button>

          </div>
          
          <div className="col-md-2 d-flex align-items-end">
            <button
              className="btn btn-outline-secondary"
              onClick={exportToExcel}
            >
              Export Excel
            </button>
          </div>
        </div>
        

        {/* Loading / Error */}
        {loading && <div className="alert alert-info">Loading...</div>}
        {error && <div className="alert alert-danger">{error}</div>}

        {/* Table */}
        <div className="table-responsive mt-3">
        {/* ===================== PENDING TABLE ===================== */}
{tableData?.length > 0 && (
  <div className="mt-3">
    <div className="d-flex justify-content-between align-items-center">
      <h5 className="mb-0 text-danger">
        Pending Returnables ({pendingRows.length})
      </h5>

      <button
        className="btn btn-sm btn-outline-primary"
        onClick={() => setShowPending(!showPending)}
      >
        {showPending ? "Collapse" : "Expand"}
      </button>
    </div>

    {showPending && renderTable(groupedPending, "pending")}
  </div>
)}

{/* ===================== COMPLETED TABLE ===================== */}
{tableData?.length > 0 && (
  <div className="mt-4">
    <div className="d-flex justify-content-between align-items-center">
      <h5 className="mb-0 text-success">
        Completed Returnables ({completedRows.length})
      </h5>

      <button
        className="btn btn-sm btn-outline-primary"
        onClick={() => setShowCompleted(!showCompleted)}
      >
        {showCompleted ? "Collapse" : "Expand"}
      </button>
    </div>

    {showCompleted && renderTable(groupedCompleted, "completed")}
  </div>
)}

        </div>
      </div>
    );
  };

  export default PendingReturnableReport;
